// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles." + {"541":"61016d83934f3f774ad6","881":"ef7efbc37fc8ce946aab","1043":"10b8aa08acd651f5a01c","1588":"2cfca1b4a67eeb9366fe","5141":"10b8aa08acd651f5a01c","5405":"baab86b206203d3567de","6256":"38f613c7a7b82c494f4f","6780":"4b87cef60aeadf57c5d3"}[chunkId] + ".css";
};